const Urls = {
	Api: {
		feedback: function (review_id) {
			return `/my/api/2/customer/reviews/${review_id}/feedback`;
		}
	}
};

export default Urls;